<template>
  <div class="paper-group" :class="[type]">
    <div v-if="type == 'pc'" style="padding: 10px 10px 0;">
      <el-popover placement="right" title="添加课程" trigger="manual" popper-class="popover-form" v-model="popoverVisible">
        <!-- <span class="circle-btn" slot="reference" @click="showPopover('show')">
          <el-button type="primary" icon="el-icon-plus" circle style="width:20px;height:20px;"></el-button>
          <span class="color-777 font-13">添加课程</span>
        </span> -->
        <el-form :model="form" :rules="rules" ref="form" label-width="80px">
          <el-form-item label="课程名称" prop="name">
            <el-input v-model="form.name" autocomplete="off" clearable placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="defaluet" @click="popoverVisible = false">取消</el-button>
            <el-button type="primary" @click="showPopover('confirm')">确定</el-button>
          </el-form-item>
          <!-- <p style="padding: 10px  0 10px 10px;text-align: center;" class="font-12 color-999">注：点击编辑按钮可以修改名称和添加文件目录。</p> -->
        </el-form>
      </el-popover>
    </div>
    <div class="industry" v-if="showGroup && tenantGroups.length > 0">
      <el-select v-model="tenantGroupId" placeholder="请选择行业" @change="tenantGroupChange" style="width: 100%;" class="text-center" popper-class="option-center">
        <el-option v-for="item in tenantGroups" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="tree-edit" v-if="editable">
      <div class="ds-box">
        <ul class="description">
          <li>
            <span class="inline-block" style="flex-shrink: 0;">说明：</span>
            <i class="iconfont icon-tianjialiebiao" style="color:#04ADC0;font-weight:600;"></i>
            <span>增加平级目录</span>
          </li>
          <li>
            <i class="el-icon-caret-bottom" style="color:#09A1DB;transform: scale(1.2);"></i>
            <span>增加下级目录</span>
          </li>
        </ul>
      </div>
      <div class="edit-box">
        <el-button type="primary" size="mini" v-if="!isEdit" @click="showEdit()">编辑</el-button>
        <el-button type="primary" size="mini" v-if="isEdit" @click="showEdit()">保存</el-button>
      </div>
    </div>
    <div class="tree-box">
      <span class="circle-btn ml-10" @click="edit('add', 1)" v-if="datas && datas.length == 0 && isEdit">
        <el-button type="primary" icon="el-icon-plus" circle></el-button><span style="display: inline-block;vertical-align: middle;margin-left: 5px;">添加</span>
      </span>
      <el-tree :expand-on-click-node="false" :data="datas" @node-expand="nodeExpand" @node-collapse="nodeExpand" :props="defaultProps" class="file-tree" node-key="uuid" :default-expand-all="false" :default-expanded-keys="expandedKeys"
        ref="tree" :filter-node-method="filterNode" :draggable="isEdit && draggable" :allow-drag="allowDrag" :allow-drop="allowDrop" @node-drop="nodeDrop">
        <div slot-scope="{node,data}" class="tree-items" @click.stop="selectTreeItem(data)" :class="{ 'active': data.id == currentItem.id && !isEdit }">
          <!-- <template v-if="type == 'pc'">
            <i class="iconfont icon-kecheng folder-icon color-yellow" v-if="data.type == 1"></i>
            <i class="iconfont icon-wenjianjia-shouqi folder-icon" v-else></i>
          </template> -->
          <template v-if="type == 'pc'">
            <i class="iconfont icon-wenjianjia-shouqi folder-icon"></i>
          </template>
          <template v-else>
            <i class="iconfont icon-louceng1 folder-icon" v-if="data.parentId == 0"></i>
            <i class="iconfont icon-ziyuan1 folder-icon" v-else></i>
          </template>
          <el-input v-model="data.name" @focus="setDraggable(false)" :id="data.uuid" placeholder="请输入内容" size="mini" class="inputname" v-if="isEdit && !data.isAll" @blur="saveData(data)"></el-input>
          <span class="name" v-else>{{ data.name }}</span>
          <span class="edit" v-if="isEdit && data.id" @mousedown="setDraggable(true)" @mouseup="setDraggable(false)">
            <span class="circle-btn" @click="edit('add', 1, data)">
              <i class="iconfont icon-tianjialiebiao" style="color:#04ADC0;font-weight:600;"></i>
            </span>
            <span class="circle-btn" @click="edit('add', 2, data)" v-if="data.cascade < 2">
              <i class="el-icon-caret-bottom" style="color:#04ADC0;transform: scale(1.1);"></i>
            </span>
            <span class="circle-btn" @click="deleted(node)">
              <i class="el-icon-delete" style="color:red;font-weight:normal;"></i>
            </span>
            <span class="circle-btn" v-if="type == 'ms'">
              <i class="el-icon-rank" style="font-weight:normal;"></i>
            </span>
          </span>
          <span class="dr" v-if="!isEdit"><i class="el-icon-right"></i></span>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: "",
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "ms",
    },
    treeType: {
      type: String,
      default: "industry",
    },
    default: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    update: "",
    showGroup: {
      type: Boolean,
      default: false,
    },
    isAll: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      datas: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        id: "uuid",
      },
      search: "",
      initForm: {
        "id": "",
        "name": "",
        "orderSort": 1,
        "parentId": "0",
        "type": 2,
      },
      form: {},
      isEdit: false,
      currentItem: {
        id: "",
        children: [],
      },
      selected: {},
      popoverVisible: false,
      rules: {
        name: [
          { required: true, message: '请输入名称' },
        ],
      },
      // datas1: [],
      // datas2: [],
      tenantGroups: [],
      tenantGroup: {},
      tenantGroupId: "",
      draggable: false,
      expandedKeys: [],
      isFirst: true,
    }
  },
  created() {

  },
  mounted() {
    if (this.showGroup) {
      if (localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code)) {
        this.tenantGroup = JSON.parse(localStorage.getItem("tenantGroup_" + this.$root.tenantInfo.code));
        this.tenantGroupId = this.tenantGroup.id;
        this.$emit('change', { tenantGroupId: this.tenantGroupId });
      }
      this.getTenantGroupds();
    }
    if (this.value) {
      this.currentItem = {
        id: this.value,
      }
    }
    this.getDatas(true);
  },
  watch: {
    popoverVisible(value) {
      if (!value) {
        document.body.classList.remove("popover-mask");
      }
    },
    update(val) {
      if (val) {
        this.currentItem = {};
        this.getDatas(true);
      }
    },
    type() {
      this.datas = [];
      this.getDatas(true);
      this.isEdit = false;
    }
  },
  methods: {
    getTenantGroupds() {
      this.loading = true;
      let params = {
        "pageIndex": 1,
        "pageSize": 100,
        "tenantCode": this.$root.tenantInfo.code,
      }
      this.https("get", this.$root.tenantInfo.code == '1' ? "/api/Tenant/GetTenantGroups" : "/api/Tenant/GetTenantGroupViewByTenantCode", params).then(res => {
        this.loading = false;
        this.tenantGroups = res.response.data || [];
        if (this.$root.tenantInfo.isLeader && !this.tenantGroup.id) {
          let data = this.tenantGroups.find(item => item.tenantCode == this.$root.tenantInfo.code) || {};
          this.tenantGroupChange(data.id);
        }
        if (!this.tenantGroup.id && this.tenantGroups.length > 0) {
          this.tenantGroupChange(this.tenantGroups[0].id);
        }
        if (this.tenantGroups.length == 0) {
          localStorage.removeItem("tenantGroup_" + this.$root.tenantInfo.code);
        }
      }).catch(res => {
        this.loading = false;
      })
    },
    tenantGroupChange(id) {
      let data = this.tenantGroups.find(item => item.id == id);
      this.tenantGroup = data;
      this.tenantGroupId = this.tenantGroup.id;
      localStorage.setItem("tenantGroup_" + this.$root.tenantInfo.code, JSON.stringify(this.tenantGroup));
      this.currentItem = {
        id: "",
        children: [],
      };
      this.getDatas(true);
      this.$emit('change', { tenantGroupId: this.tenantGroupId });
    },
    searchTree() {
      if (this.$refs.tree) {
        this.$refs.tree.filter(this.search)
      };
    },
    allowDrop(draggingNode, dropNode, type) {
      if (this.isEdit) {
        if (type == "inner" && draggingNode.data.cascade > dropNode.data.cascade) {
          return true;
        }
        if ((type == "prev" || type == "next") && dropNode.data.cascade == draggingNode.data.cascade) {
          return true;
        }
      }
      return false;
    },
    setDraggable(draggable) {
      console.log(draggable)
      this.draggable = draggable;
    },
    allowDrag(node) {
      if (this.isEdit && node.data.sourceType == 99) {
        return true;
      }
      return false;
    },
    nodeExpand(data, node) {
      setTimeout(() => {
        let index = this.expandedKeys.findIndex(id => data.id == id);
        if (node.expanded && index < 0) {
          this.expandedKeys.push(data.id);
        } else if (!node.expanded && index >= 0) {
          this.expandedKeys.splice(index, 1);
        }
      })
    },
    nodeDrop(draggingNode, dropNode, type) {
      draggingNode.data.position = type;
      draggingNode.data.targetId = dropNode.data.id;
      if (type == "before") {
        draggingNode.data.orderSort = dropNode.data.orderSort;
        draggingNode.data.parentId = dropNode.data.parentId;
      } else if (type == "after") {
        draggingNode.data.orderSort = dropNode.data.orderSort;
        draggingNode.data.parentId = dropNode.data.parentId;
      } else if (type == "inner") {
        draggingNode.data.orderSort = 1;
        draggingNode.data.parentId = dropNode.data.id;
      }
      this.saveData(draggingNode.data);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    showEdit() {
      this.isEdit = !this.isEdit;
      if (!this.isEdit) {
        this.getDatas(true);
      }
    },
    getDatas(loading) {
      if (!this.tenantGroup.id && this.showGroup) {
        return;
      }
      this.loading = loading;
      var params = {
        tenantGroupId: this.tenantGroup.id || "",
      }
      let url = "";
      if (this.type == "pc") {
        url = "/api/TestPaper/OneselffTestPaperGroupTree";
      } else if (this.type == "quote") {
        url = "/api/TestPaper/GetTestPaperGroupTreeByTeacher";
      } else if (this.type == "ms") {
        url = "/api/TestPaper/GetTestPaperGroupTreeByTenantAdmin";
        if (this.$root.tenantInfo.isLeader || this.$root.tenantInfo.code == '1') {
          url = "/api/TestPaper/GetTestPaperGroupTreeByTenantGroup";
        }
      }
      this.https("get", url, params).then(res => {
        this.loading = false;
        if (res.response) {
          this.datas = res.response.children || [];
        } else {
          this.datas = [];
        }
        if (this.isAll && this.datas.length > 0) {
          this.datas = [{ id: "", name: "全部", parentId: 0, isAll: true, }, ...this.datas];
        }
        // this.datas1 = this.datas.filter(item => item.type == 1);
        // this.datas2 = this.datas.filter(item => item.type == 2);
        this.setChildren(null, this.datas);
        if (this.isFirst) {
          this.expandedKeys = this.datas.map(item => { return item.id });
          this.isFirst = false;
        }
        this.updateTree();
        // if (this.datas.length == 0 && this.type == "pc") {
        //   this.showPopover("show");
        // }
        if (this.type == "quote") {
          this.$emit('setSubjectCatalogue', 'get', this.datas);
        }
      }).catch(res => {
        this.loading = false;
      });
    },
    setChildren(data, arr) {
      arr.map((item, index) => {
        item.children = item.children || [];
        item.uuid = item.id;
        item.index = index + 1;
        if (data) {
          item.sequence = data.sequence + "." + item.index;
        } else {
          item.sequence = item.index + "";
        }
        if (!this.currentItem.id && this.default) {
          this.selectTreeItem(item);
        }
        if (item.children.length > 0) {
          this.setChildren(item, item.children);
        }
      })
    },
    saveData(params) {
      params.position = params.position || "";
      if (!params.position) {
        params.targetId = "";
      }
      if (!params.targetId) {
        params.position = "";
      }
      params.enterable = false;
      if (params.name.replace(/(^\s*)|(\s*$)/g, "") == "") {
        this.$refs.tree.remove(params.uuid);
        this.updateTree();
        return;
      }
      // this.loading = true;
      let url = "";
      if (this.type == "pc") {
        url = "/api/TestPaper/AddOrEditPrivateTestPaperGroup";
      } else if (this.type == "ms") {
        url = "/api/TestPaper/AddOrEditTestPaperGroupByTeant";
        if (this.$root.tenantInfo.isLeader) {
          url = "/api/TestPaper/AddOrEditPublicTestPaperGroup";
        }
      }
      this.https("post", url, params).then(res => {
        this.loading = false;
        if (res.success) {
          this.getDatas(false);
          this.popoverVisible = false;
          // this.func.message("success", res.msg);
        } else {
          this.func.message("error", res.msg);
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    edit(mode, level, item) {
      this.selected = item || {};
      this.selected.children = this.selected.children || [];
      if (level == 2) {
        if (this.expandedKeys.indexOf(item.id) < 0) {
          this.expandedKeys.push(item.id);
        }
      }
      if (mode == "add") {
        if (this.datas.length == 0) {
          this.isEdit = true;
        }
        this.form = this.func.depCopy(this.initForm);
        if (this.treeType == "personal") {
          this.form.sourceType = 99;
        }
        if (this.type == "ms") {
          this.form.tenantGroupId = this.tenantGroup.id;
        }
        this.form.uuid = this.func.uuid(10);
        if (level == 1) {
          this.form.parentId = this.selected.parentId || "0";
          this.form.orderSort = this.selected.orderSort;
          if (this.datas.length == 0) {
            this.datas.push(this.form);
          } else {
            this.$refs.tree.insertAfter(this.form, this.selected.uuid);
          }
          this.form.position = "after";
          this.form.targetId = this.selected.id;
        } else {
          this.form.parentId = this.selected.id;
          this.form.position = "inner";
          this.form.targetId = this.selected.id;
          if (this.selected.children.length > 0) {
            let target = this.selected.children[0];
            this.form.orderSort = target.orderSort;
            this.$refs.tree.insertBefore(this.form, target.uuid);
          } else {
            this.form.orderSort = 1;
            this.$refs.tree.append(this.form, this.selected.uuid);
          }
        }
      } else if (mode = "edit") {
        this.form = this.func.depCopy(item);
      }
      this.form.enterable = true;
      setTimeout(() => {
        document.getElementById(this.form.uuid).focus();
      });
    },
    updateTree() {
      setTimeout(() => {
        this.searchTree();
      })
    },
    selectTreeItem(item) {
      if (this.isEdit) {
        return;
      }
      this.updateTree();
      this.currentItem = item;
      let data = this.func.depCopy(item);
      if (data.sourceType == 0) {
        data.id = data.children.map(item => { return item.id }).toString();
      }
      this.$emit('change', data);
    },
    deleted(node, callback) {
      if (!node.data.id) {
        this.$refs.tree.remove(node.data.uuid);
        this.updateTree();
        return;
      }
      let params = {
        id: node.data.id,
      }
      this.$confirm(`是否确定删除“${node.data.name}”`, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.https("delete", "/api/TestPaper/DelTestPaperGroupById", params).then(res => {
          this.loading = false;
          if (typeof callback == "function") {
            callback(res.success)
          } else {
            if (res.success) {
              this.getDatas(false);
            } else {
              this.func.message("error", res.msg);
            }
          }
        }).catch(() => {
          this.loading = false;
        })
      });
    },
    showPopover(type) {
      if (type == "show") {
        document.body.classList.add("popover-mask");
        this.form = this.func.depCopy(this.initForm);
        this.form.type = 1;
        this.popoverVisible = true;
        this.isEdit = false;
        if (this.$refs["form"]) {
          this.$refs["form"].resetFields();
        }
      } else if (type == "confirm") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.saveData(this.form);
          } else {
            return false;
          }
        })
      }
    },
  }
}
</script>
<style>
.paper-group .file-tree .el-tree-node__content {
  height: auto;
}

.popover-mask > .pswp {
  display: block;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
}
</style>
<style lang="scss" scoped>
.paper-group {
  position: relative;
  height: 100%;
  overflow: auto;
  .industry {
    padding: 15px 15px 5px 15px;
    // border-bottom: 1px solid #eee;
  }

  .tree-edit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }

  .ds-box {
    // display: flex;

    .description {
      display: inline-block;
      vertical-align: middle;
      font-size: 13px;
      // flex: 1;
      // display: flex;

      li {
        display: inline-flex;
        align-items: center;
        color: #999;
        white-space: nowrap;

        i {
          margin-right: 2px;
        }
      }
    }
  }

  .edit-box {
    // margin-top: 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > .el-button {
      min-width: 50px;
    }
  }

  .tree-box {
    flex: 1;
    overflow: auto;
    padding: 15px 10px;
    // position: absolute;
    // left: 0;
    // top:45px;
    // bottom: 0;
    // right: 0;
  }

  .tree-items {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px 5px;
    border-radius: 0px;
    flex: 1;
    position: relative;
    height: 34px;
    .sequence {
      font-size: 13px;
    }

    .edit {
      // margin-left: 20px;
      position: relative;
      display: flex;
      min-width: 50px;
      justify-content: flex-end;
    }

    &:hover {
      cursor: pointer;
      background-color: #fbfbfb;
    }

    &.active {
      background-color: #e8f8f8;
    }

    .name {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      white-space: nowrap;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      padding: 0 20px;
    }

    .dr {
      position: absolute;
      font-size: 13px;
      padding: 0 5px;
      line-height: 20px;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);

      &:hover {
        color: #04adc0;
      }

      & > i {
        position: relative;
        top: 50%;
        font-size: 14px;
      }
    }

    & > span {
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .folder-icon {
    // font-weight: bold;
    margin-right: 2px;
    color: #04adc0;
    width: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PaperGroup.vue